<template>
    <div>
        <h1 style="text-align: center;"><br/><icon name="cog" scale="5"></icon><br/>Control Panel</h1>
        <br/>&nbsp;
        <div class="col-md-12">
            <div class="row justify-content-center " align="center">
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="cog" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/hr/general"><h4>General Settings</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="building" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/company/companies"><h4>Companies</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="list" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/company/branches"><h4>Branches</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="address-book" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/company/departments"><h4>Departments</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="briefcase" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/company/designations"><h4>Designations</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="calendar" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/hr/leaves"><h4>Leave Types</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="cog" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/hr/shift_categories"><h4>Shift Categories</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="plane" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/company/holidays"><h4>Holidays List</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="lock" scale="3"></icon></div>
                    <router-link style="color: black;" to="/settings/roles"><h4>Security and Permissions</h4></router-link>
                </div>
                <div class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="thumbs-up" scale="3"></icon></div>
                    <router-link style="color: black;" to="/hr/machines"><h4>Machines</h4></router-link>
                </div>
            </div>
            <br/>
        </div>
    </div>
</template>
<script>
  import {mixin} from '@/mixins/mixins';
  export default {
  mixins: [mixin],
}
</script>


// WEBPACK FOOTER //
// src/components/settings/settings-start.vue